module.exports = __webpack_public_path__ + "img/compare-img.0988cc28.svg";